export const VIRTUALIZED_LIST_SCROLL_CONTAINER_CLASS = "virtualised-list";

export interface IVirtualizedListExpose<T> {
  refreshView: () => void;
  scrollToNode: (findItemFn: (item: T) => boolean) => void;
  scrollToIndex: (index: number) => void;
}
